import { preAssign } from '../redux/new_services/device';
import useModal from '@/lib/hooks/useModal';

export const useOpenDeviceWizard = () => {
  const [openDeviceWizard] = useModal('CREATE_DEVICE');
  const [displayNoFreeLicences] = useModal('NO_FREE_LICENCES');
  const handleCreateNewDevice = (locationID) => {
    preAssign().then((result) => {
      if (result) {
        openDeviceWizard({locationID: locationID});
      } else {
        displayNoFreeLicences();
      }
    })
  };

  return handleCreateNewDevice;
}

export const useConfirmClosingForm = () => {
  const [confirmClosingUnsavedForm] = useModal('CLOSE_UNSAVED_FORM_MODAL');
  return (next = () => {}) => confirmClosingUnsavedForm({ next: next });
}
export const useSelectStream = ({title = "Wähle einen Stream"} = {}) => {

  const [showSelectStreamModal] = useModal('SELECT_STREAM');
  return (selectStream = () => {}) => showSelectStreamModal(
    {
      onSelectStream: (streams) => {
        selectStream(streams[0])
      },
      title: title || "Wähle einen Stream"
    }
  );
}


export const useConfirmRemoveSomething = (title, message) => {
  const [confirmRemove] = useModal('CONFIRM_REMOVE');
  return (next = () => {}) => confirmRemove({title, message, next: next });
}
